/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.markersContainer[_ngcontent-%COMP%] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  margin-left: auto;\n  margin-right: auto; }\n\n.progressMarker[_ngcontent-%COMP%] {\n  background-color: white;\n  margin-right: 5px;\n  border: 1px solid #cacaca;\n  height: 16px;\n  width: 16px; }\n\n.coloredProgressMarker[_ngcontent-%COMP%] {\n  background-color: white;\n  height: 8px;\n  width: 8px;\n  margin-left: 4px;\n  margin-top: 4px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9wcm9ncmVzcy9wcm9ncmVzcy1ib3guY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./aot_output/src/app/progress/progress-box.component.scss.shim.ngstyle.ts